import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    VStack,
    HStack,
    Box,
} from '@chakra-ui/react';
import type { InvoiceStatus } from '../../types/invoice';
import { INVOICE_LIST_STATUS_META } from '../../components/invoice/invoiceListStatusConfig';
import { InvoiceListStatusBadge } from '../../components/invoice/InvoiceListStatusBadge';
import { useIsOverflowing } from '../../hooks/useIsOverflowing';

export interface InvoiceStatusHelpModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const STATUS_ORDER: InvoiceStatus[] = ['flagged', 'submitted', 'manually_submitted'];

const InvoiceStatusHelpModal = ({ isOpen, onClose }: InvoiceStatusHelpModalProps) => {
    const [bodyRef, bodyOverflows] = useIsOverflowing(isOpen);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" scrollBehavior="inside" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader
                    fontSize="lg"
                    fontWeight="semibold"
                    color="gray.800"
                    pr={10}
                    borderBottomWidth={bodyOverflows ? '1px' : '0'}
                    borderBottomStyle="solid"
                    borderColor="gray.300"
                >
                    Invoice statuses
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody ref={bodyRef} minH={0} pb={2}>
                    <VStack align="stretch" spacing={4}>
                        <Text fontSize="sm" color="gray.600" lineHeight="tall">
                            The Status column shows where each invoice is in the NEX submission workflow. Each value
                            appears as the same badge here as on the list.
                        </Text>
                        {STATUS_ORDER.map((status) => (
                            <HStack key={status} align="flex-start" spacing={3} flexWrap="wrap">
                                <Box flexShrink={0} pt="2px">
                                    <InvoiceListStatusBadge status={status} />
                                </Box>
                                <Text fontSize="sm" color="gray.600" lineHeight="tall" flex="1" minW="200px">
                                    {INVOICE_LIST_STATUS_META[status].modalExplanation}
                                </Text>
                            </HStack>
                        ))}
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button size="action" variant="outline" onClick={onClose}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InvoiceStatusHelpModal;
